var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/tick-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99992 1.83325C4.32659 1.83325 1.33325 4.82659 1.33325 8.49992C1.33325 12.1733 4.32659 15.1666 7.99992 15.1666C11.6733 15.1666 14.6666 12.1733 14.6666 8.49992C14.6666 4.82659 11.6733 1.83325 7.99992 1.83325ZM11.1866 6.96659L7.40659 10.7466C7.31325 10.8399 7.18659 10.8933 7.05325 10.8933C6.91992 10.8933 6.79325 10.8399 6.69992 10.7466L4.81325 8.85992C4.61992 8.66659 4.61992 8.34659 4.81325 8.15325C5.00659 7.95992 5.32659 7.95992 5.51992 8.15325L7.05325 9.68659L10.4799 6.25992C10.6733 6.06659 10.9933 6.06659 11.1866 6.25992C11.3799 6.45325 11.3799 6.76659 11.1866 6.96659Z",
    fill: "#2F9801"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircleGreen);
export default __webpack_public_path__ + "static/media/tick-circle-green.a828bd768bde7df98f3a56c85b67e4bc.svg";
export { ForwardRef as ReactComponent };